import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';

import { MessagesService }       from '../messages/messages.service';
import { VVGarageCustomerModel } from './typings/vv-garage.customer';
import { VVGarageService }       from './vv-garage.service';

@Component({
  selector   : 'vv-garage-add-customer',
  template: require('./vv-garage.add-customer.component.html')
})
export class VVGarageAddCustomerComponent {
  @BlockUI('vvGarageAddCustomerBlock') block: NgBlockUI;

  @Input() customer: VVGarageCustomerModel;

  constructor (
    public  activeModal    : NgbActiveModal,
    private messagesService: MessagesService,
    @Inject(forwardRef(() => VVGarageService))
    private vvGarageService: VVGarageService
  ) {}

  create () : void {
    this.block.start();

    this.vvGarageService.createCustomer(this.customer)
    .then(() => this.activeModal.close())
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
